<template>
	<v-app class="landing" :style="{ background: $vuetify.theme.themes[theme].landingBackground }">
		<component :is="AppBar" v-if="ready" />

		<second-bar v-if="ready && landingSettings && landingSettings.siteTheme !== 2" />

		<default-view v-if="ready" />

		<component :is="Footer" v-if="ready" />

		<div class="page-loading" v-if="!ready">
			<div class="loading">
				<div class="logo-image">
					<img :src="`/logo-wide.png`" style="max-width: 150px" alt="App Logo" />
				</div>
				<v-progress-circular :size="50" color="primary" indeterminate />
			</div>
		</div>
	</v-app>
</template>

<script>
	import { get, call } from 'vuex-pathify'
	import { setCookie, getCookie } from '@/util/helpers'
	import api from '@/util/app-api'
	import ThemeManager from '@/util/theme-manager.js'

	export default {
		name: 'DefaultLayout',

		components: {
			SecondBar: () => import(
				/* webpackChunkName: "default-app-bar" */
				'./SecondAppBar'
			),
			DefaultView: () => import(
				/* webpackChunkName: "default-view" */
				'./View'
			),
		},
		data() {
			return {
				ready: false
			}
		},
		computed: {
			theme() {
				return (this.$vuetify.theme.dark) ? 'dark' : 'light'
			},
			...get('siteConfig', [
				'isCloud'
			]),
			...get('appSettings', [
				'landingSettings'
			]),
			AppBar() {
				return () => {
					switch (this.landingSettings?.siteTheme) {
						case 1:
							return import('./NafisTheme/AppBar.vue')
						case 2:
							return import('./SafeGolds/AppBar.vue')
						default:
							return import('./AppBar.vue')
					}
				}
			},
			Footer() {
				return () => {
					switch (this.landingSettings?.siteTheme) {
						case 1:
							return import('./NafisTheme/Footer.vue')
						case 2:
							return import('./SafeGolds/Footer.vue')
						default:
							return import('./Footer.vue')
					}
				}
			}
		},
		created() {
			ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify).then(res => {
				this.ready = true
			}).catch(err => {
				this.ready = true
			})
		},
		mounted() {
			this.manageAffiliate()
			this.manageAgentCode()
		},
		methods: {
			manageAffiliate() {
				let mrk = this.$route.query.mrk
				if (!mrk)
					return

				setCookie('mrk', mrk, 180)

				let customerCode = this.$route.params.customerCode || 0
				api.post(`Visitor/LogVisitor/?customerCode=${customerCode}&mrkCode=${mrk}`, {}, { authHeader: false, contentType: 'application/json' })
					.then(response => {
					})
					.catch(err => {
					})
			},
			manageAgentCode() {
				let agn = this.$route.query.agn
				if (!agn)
					return

				setCookie('agn', agn, 180)
			}
		},
	}
</script>
